import React from "react"
import {FieldViewProps} from "../../../../render/view";
import DropdownValue from "../../../../generic/dropdown/components/dropdown-value";


export default function FieldCrmAccount_View(props: FieldViewProps) {

    const option = props.field._getOption(props.model[props.field.fieldId])

    switch (props.params?.viewType) {

        // _getOption returns false when the value has no option (an account the cached options
        // predate, a deleted one) - reading .label off it throws and takes the whole view down
        case 'name-only':
            return <div className={props.className}>{option ? option.label : null}</div>

        default:
            return <DropdownValue className={props.className} option={option} field={props.field} />
    }

}